import { DashValidation } from 'dash-common';
import {
  Flex,
  Form,
  Input,
  FormContext,
  type IInputProps,
} from 'dash-ui';
import styled from 'styled-components';
import { type ChangeEvent, type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

export const NumberInput = styled(Input)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

const ZipCodeInput: FC<IInputProps> = ({ ...inputProps }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.value.length <= DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](e.target.value);
        valid(fieldName, e.target.value);
      }
    };

  return (
    <Flex flexDirection="column" w={88}>
      <Form.Label required>{t('forms:labels.zipCode')}</Form.Label>
      <NumberInput
        value={formState.zipCode || ''}
        placeholder={t('forms:placeholders.digits', { number: 5 }) || ''}
        type="number"
        onChange={onChange(FormFields.ZipCode)}
        $errorType={formErrors[FormFields.ZipCode]?.type}
        {...inputProps}
      />
      <Form.Feedback $errorType={formErrors[FormFields.ZipCode]?.type}>
        {formErrors[FormFields.ZipCode]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default ZipCodeInput;
